import React, { Component } from 'react';
import { node, func, string } from 'prop-types';
import styles from './styles';

class Modal extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    document.body.style.overflowY = 'hidden';
    document.body.style.height = '100vh';
  }

  componentWillUnmount() {
    document.body.style.overflowY = 'inherit';
    document.body.style.height = 'inherit';
  }

  render() {
    const { cssHook, onClose } = this.props;
    return (
      <div className="Modal__backdrop" onClick={onClose} role="presentation">
        <style jsx>{styles}</style>
        <div
          className={`Modal ${cssHook || ''}`}
          onClick={e => e.stopPropagation()}
          role="presentation"
        >
          {this.props.children}
        </div>
      </div>
    );
  }
}

/* eslint-disable react/require-default-props */
Modal.propTypes = {
  children: node,
  cssHook: string,
  onClose: func.isRequired
};

export default Modal;
